/**
 * The one "(i)" with its help text: an InfoDot carrying a label, one or more
 * paragraphs and a test id.
 *
 * DEDUP-1: Attest (wizardHelp, IndependenceStep) and Valuation (_HelpDot) each
 * had their own copy. Each product keeps only its text map and calls this.
 * A single string renders as-is; a list renders one block per paragraph.
 */
import { InfoDot } from '@/components/ui/info-dot'

export interface HelpDotProps {
  /** The field this help belongs to. Becomes the accessible name. */
  label: string
  paragraphs: string | readonly string[]
  /** Usually `info-<field-id>`. */
  testId: string
  className?: string
}

export function HelpDot({ label, paragraphs, testId, className }: HelpDotProps) {
  return (
    <InfoDot label={label} className={className} data-testid={testId}>
      {typeof paragraphs === 'string'
        ? paragraphs
        : paragraphs.map((p, i) => (
            <span key={i} className={i ? 'mt-2 block' : 'block'}>{p}</span>
          ))}
    </InfoDot>
  )
}
